import {InputTextV2} from '@prtimes-basis/input';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function PresidentNameField() {
  return (
    <FormField.Root name='companyInfo.presidentName'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <InputTextV2
      required
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
